import { DEFAULT } from './default'
// MOG / PEPE are placeholder skins shared with Defender until Howzzat gets its
// own — only the DEFAULT (launch) theme differs (the cricket accent).
import { MOG } from '../defender/mog'
import { PEPE } from '../defender/pepe'

export const HOWZZAT_THEMES = { DEFAULT, MOG, PEPE }
